// extracted by mini-css-extract-plugin
export default {"authLayoutLogo":"logo_authLayoutLogo__3it3q","authLogoPartOne":"logo_authLogoPartOne__yXgVN","authLogoPartTwo":"logo_authLogoPartTwo__HGyK9","mTradeLogo":"logo_mTradeLogo__TxedM"};